import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, mapProps } from 'recompose'
import {TableCell} from 'react-toolbox/lib/table'
import * as R from 'ramda'

import {
  enhance,
  withModifyProps,
  withViewProps,
  ViewTable,
  ModifyTable
} from 'containers/Admin/Table/index'

import styles from './styles.scss'

const tableHeadContent = {
    name: (<TableCell key={0}>Name</TableCell>),
    username: (<TableCell key={1}>Username</TableCell>),
    email: (<TableCell key={2}>Email</TableCell>),
    action: (<TableCell key={3}>&nbsp;</TableCell>)
}

const modifiedTableHeadContent = {
    ...tableHeadContent,
    action: (<TableCell key={3}>Edit</TableCell>)
}


const withModelProps = mapProps(
    ({ selectable, ...rest }) => ({
        ...rest,
        selectable,
        tableHeadContent: selectable ? modifiedTableHeadContent : tableHeadContent
    })
)

const withStyle = CSSModules(styles)

const EnhancedViewTable = compose(
  withViewProps,
  withStyle
)(ViewTable)

const EnhancedModifyTable = compose(
  withModifyProps,
  withStyle
)(ModifyTable)

export default compose(
  withModelProps,
  enhance
)(EnhancedModifyTable, EnhancedViewTable)
